module.exports = __webpack_public_path__ + "static/img/li3_4.bc9ce31f.png";